var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "provider-extern-mailing-conf" },
    [
      _c("CompassDialog", {
        attrs: {
          visible: _vm.showModal,
          size: "small",
          title: _vm.$t.__(
            "preferences.ProviderExternMailingConf.change_campaign_sending_service"
          )
        },
        on: {
          "update:visible": function($event) {
            _vm.showModal = $event
          },
          closed: _vm.closePopup
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__default" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "flex-column",
                        model: {
                          value: _vm.providerSelected,
                          callback: function($$v) {
                            _vm.providerSelected = $$v
                          },
                          expression: "providerSelected"
                        }
                      },
                      _vm._l(_vm.providers, function(provider, key) {
                        return _c("el-radio", {
                          key: provider.id,
                          staticClass: "flex-row ai-center",
                          class: key !== _vm.providers.length - 1 ? "mb-4" : "",
                          attrs: { label: provider.id },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "flex-row ai-center" },
                                      [
                                        _c("SaasIcon", {
                                          attrs: {
                                            width: 40,
                                            height: 40,
                                            icon: provider.icon
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "semibold fs-3 ml-2 gray-100 lh-20"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(provider.name) +
                                                "\n                                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        provider.id === 1 || provider.id === 4
                                          ? _c("tag-rounded", {
                                              staticClass: "ml-2 semibold py-1",
                                              attrs: {
                                                label: _vm.$t.__(
                                                  "common.labels.by_default"
                                                ),
                                                color: "gray-60 ",
                                                radius: 44,
                                                bgcolor: "secondary-grey"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: { click: _vm.closePopup }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.continue"),
                        type: "primary"
                      },
                      on: { click: _vm.onProviderChanged }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "service-campaign-container" },
        [
          _c(
            "div",
            { staticClass: "service-campaign-subcontainer" },
            [
              _vm.provider.icon
                ? _c("SaasIcon", {
                    attrs: { width: 40, height: 40, icon: _vm.provider.icon }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "bold fs-4 ml-2" }, [
                _vm._v(_vm._s(_vm.provider.name))
              ]),
              _vm._v(" "),
              _vm.provider.id === 1 || _vm.provider.id === 4
                ? _c(
                    "div",
                    { staticClass: "ml-2" },
                    [
                      _c("tag-rounded", {
                        staticClass: "semibold py-1 default-tag",
                        attrs: {
                          label: _vm.$t.__("common.labels.by_default"),
                          color: "gray-60 ",
                          radius: 44,
                          bgcolor: "secondary-grey"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-5",
            attrs: { label: _vm.$t.__("common.actions.edit"), type: "primary" },
            on: { click: _vm.onModifProvider }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }